import type { SearchIndexEntry } from "@/types";
import { parseFeedDate } from "@/utils/messageId";

/** Для навигации ↑ старее, ↓ новее. */
export function sortSearchResultsChrono(
  results: SearchIndexEntry[]
): SearchIndexEntry[] {
  return [...results].sort(
    (a, b) => parseFeedDate(a.date) - parseFeedDate(b.date)
  );
}

export function findSearchResultIndex(
  results: SearchIndexEntry[],
  messageId: string
): number {
  const key = String(messageId);
  return results.findIndex((r) => String(r.id) === key);
}
